var React = require('react');

function NavIconsInvitations (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m8.16 10.6a3.49 3.49 0 1 1 3.48-3.49 3.49 3.49 0 0 1 -3.48 3.49zm0-5.6a2.08 2.08 0 1 0 2.07 2.07 2.08 2.08 0 0 0 -2.07-2.07z","key":0}),React.createElement("path",{"d":"m13.09 20.55h-9.86v-4.72a4.4 4.4 0 0 1 4.39-4.39h1.08a4.4 4.4 0 0 1 4.39 4.39zm-8.45-1.42h7v-3.3a3 3 0 0 0 -3-3h-1.02a3 3 0 0 0 -3 3z","key":1}),React.createElement("path",{"d":"m17.02 14.93-1.33-.01-.02-9.19h1.32z","key":2}),React.createElement("path",{"d":"m11.74 11 .01-1.32 9.19-.03v1.33z","key":3})]);
}

NavIconsInvitations.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsInvitations;

NavIconsInvitations.default = NavIconsInvitations;
